// @flow
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { List } from 'material-ui/List';
import { translate } from 'react-i18next';
import moment from 'moment';

import Images from 'statsradio/themes/Images';

import History from '../domain/History';
import type { MonthData } from '../domain/History';
import HistoryListMonth from '../components/HistoryListMonth';

const DATE_FORMAT = 'MMMM - YYYY';

const WrappedList = styled(List)`
  flex: 2;
  overflow-y: auto;

  & > div {
    border-bottom: 2px solid #dadce0;
  }

  & > div > div > div:not(:last-child){
    border-bottom: 1px solid #dadce0;
  }
`;

const PlaceholderImage = styled.img`
  width: 70px;
  opacity: 0.6;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ErrorMessage = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  max-width: 200px;
  text-align: center;
`;

type Props = {
  data: History,
  selectedDate?: moment,

  t: any,
  theme: any,
}

type State = {
  selectedDate?: moment,
  openedMonths: string[],
}

class HistoryList extends Component<Props, State> {
  state = {
    selectedDate: this.props.selectedDate,
    openedMonths: [],
  };

  componentDidUpdate(prevProps: Props) {
    const { selectedDate } = this.props;
    if (selectedDate && !selectedDate.isSame(prevProps.selectedDate, 'day')) {
      this.displaySelectedDate();
    }
  }

  displaySelectedDate() {
    const { selectedDate } = this.props;
    if (selectedDate) {
      this.setState({ openedMonths: [selectedDate.format(DATE_FORMAT)], selectedDate: selectedDate });
    }
  }

  render() {
    const { t } = this.props;

    const displayError = this.props.data === undefined;
    const displayNoData = !displayError && this.props.data && this.props.data.isEmpty();
    const displayData = !displayError && !displayNoData && this.props.data;

    const data = !displayData ? [] : this.props.data.groupByMonth();

    return (
      <React.Fragment>
        {displayData &&
          <WrappedList>
            {data.map(m => <HistoryListMonth
              key={m.month}
              month={m}
              open={this.isSelected(m)}
              onClick={this.openMonth}
              selectedDate={this.state.selectedDate}
            />)}
          </WrappedList>
        }
        {(displayError || displayNoData) &&
          <ImageWrapper>
            <PlaceholderImage src={Images.emptyAgeRange} alt={`${t('weeksWillBeDisplayedHere')}`} />
            <ErrorMessage>{t('weeksWillBeDisplayedHere')}</ErrorMessage>
          </ImageWrapper>
        }
      </React.Fragment>
    );
  }

  isSelected = (month: MonthData) => {
    return this.state.openedMonths.includes(month.month);
  };

  openMonth = (key: string) => {
    const { openedMonths, selectedDate } = this.state;
    const index = openedMonths.indexOf(key);

    if (selectedDate && key === selectedDate.format(DATE_FORMAT)) {
      this.setState({ selectedDate: undefined });
    }

    if (index !== -1) {
      openedMonths.splice(index, 1);
    } else {
      openedMonths.push(key);
    }

    this.setState({ openedMonths });
  };
}

export default withTheme(translate('history')(HistoryList));



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryList.js